import React from "react";

export default function CommonLabel({
  labelText = "some label...",
  required = false,
  // textColor="text-cInputLabel",
  textSize="text-fs14"
}) {
  return (
    <div className={`capitalize ${textSize} font-fw500 text-black`}>
      {labelText}
      {required ? <span className="text-cRed"> *</span> : ""}
    </div>
  );
}
